import type { NotificationItem } from '@/types/notifications';

const KIND_LABELS: Record<string, string> = {
  provenance_sent_back: 'Provenance sent back',
  provenance_rejected: 'Provenance rejected',
  provenance_approved: 'Provenance approved',
  provenance_review_overdue: 'Provenance review overdue',
  escrow_paid: 'Payment received',
  escrow_accepted: 'Sale accepted',
  escrow_shipped: 'Artwork shipped',
  escrow_transfer_completed: 'Ownership transferred',
  escrow_payout_sent: 'Payout sent',
  escrow_cancelled: 'Sale cancelled',
  escrow_admin_review: 'Admin check',
  escrow_on_hold: 'Sale on hold',
  escrow_reminder: 'Reminder',
  payment_method_changed: 'Payout method changed',
  system_announcement: 'Announcement',
  system_product_update: 'Product update',
  system_policy_update: 'Policy update',
};

export interface NotificationCopy {
  /** Short label for the kind. Empty for a kind we do not know. */
  label: string;
  title: string;
  message: string;
}

/** Text to show for a row. A kind we do not know shows title and message as sent. */
export function notificationCopy(item: NotificationItem): NotificationCopy {
  return {
    label: KIND_LABELS[item.kind] ?? '',
    title: item.title,
    message: item.message,
  };
}
